// extracted by mini-css-extract-plugin
export default {"trust":"Trust_trust__3AZGS","content":"Trust_content__-GI5s","box-info":"Trust_box-info__8iEFa"};